
    import './styles.scoped.css';
    export default {
  "toggle": "awsui_toggle_1uo6m_117ru_103",
  "drawer-triggers": "awsui_drawer-triggers_1uo6m_117ru_109",
  "drawer": "awsui_drawer_1uo6m_117ru_109",
  "drawer-mobile": "awsui_drawer-mobile_1uo6m_117ru_119",
  "drawer-closed": "awsui_drawer-closed_1uo6m_117ru_122",
  "drawer-content": "awsui_drawer-content_1uo6m_117ru_129",
  "drawer-content-clickable": "awsui_drawer-content-clickable_1uo6m_117ru_141",
  "drawer-resize-content": "awsui_drawer-resize-content_1uo6m_117ru_151",
  "drawer-triggers-wrapper": "awsui_drawer-triggers-wrapper_1uo6m_117ru_157",
  "drawer-trigger": "awsui_drawer-trigger_1uo6m_117ru_109",
  "drawer-trigger-active": "awsui_drawer-trigger-active_1uo6m_117ru_176",
  "hide": "awsui_hide_1uo6m_117ru_184"
};
  